<template>
    <div
        class="d-flex justify-content-center flex-column align-items-center mt-xl-0"
        v-if="papers && papers.length"
    >
        <div id="wrap-papers-table">
            <div v-if="type === 'meetup'">
                <div class="table-header pb-3">
                    <div
                        v-for="field in fields"
                        :key="field.key"
                        class="field-label"
                        :class="type+'-header'"
                    >{{field.label}}</div>
                </div>
                <div
                    class="table-row"
                    v-for="paper in papers"
                    :key="paper.slug"
                    :class="type+'-row'"
                >
                    <div
                        v-for="field in fields"
                        :key="field.key+'-'+paper.slug"
                        :class="(field.key+' '+(type+'-'+field.key))"
                    >
                        <div
                            v-if="field.key==='title'"
                            class="txt-title-papers mt-0"
                        >{{paper.title}}</div>
                        <div v-else-if="field.key==='event'" class="txt-title-papers">
                            <div class="only-mobile mt-3 txt-table-mobile">Submitted to</div>
                            {{paper.event_name}}
                        </div>
                        <div v-else-if="field.key==='speaker'">
                            <img :src="paper.speaker_photo_url" class="speaker-photo mr-2" />
                            {{paper.speaker_firstname}} {{paper.speaker_lastname}}
                        </div>
                        <div v-else-if="field.key==='length'">
                            {{paper.duration}}
                            <span class="ml-1 no-mobile">minutes</span>
                            <span class="only-mobile align-items-center">
                                '
                                <i class="material-icons ml-1">access_time</i>
                            </span>
                        </div>
                        <div v-else-if="field.key==='status'">
                            <paper-status :status="paper.state"></paper-status>
                        </div>
                        <div v-else-if="field.key==='level'">{{levelData[paper.level]}}</div>
                        <div v-else-if="field.key==='actions'">
                            <span class="d-flex align-items-center" v-if="type === 'meetup'">
                                <i
                                    class="material-icons mt-2 m-lg-0"
                                    @click="currentPaper = paper; stateChangeConfirm = true; statusChange = 'approve'"
                                    v-if="paper.state === 'WAITING_FOR_APPROVAL'"
                                >check</i>
                                <i
                                    class="material-icons-outlined thumb"
                                    @click="openProposalInfo(paper, true)"
                                >info</i>
                                <i
                                    class="material-icons thumb"
                                    :class="{approved: paper.state === 'APPROVED', rejected: paper.state === 'NOT_APPROVED'}"
                                    v-if="paper.state !== 'WAITING_FOR_APPROVAL'"
                                >{{paper.state === "APPROVED" ? "thumb_up" : "thumb_down"}}</i>
                            </span>
                            <span v-else-if="type === 'speaker'">
                                <md-menu md-size="auto" md-direction="bottom-end">
                                    <md-button class="md-icon-button edit-btn" md-menu-trigger>
                                        <md-icon>more_vert</md-icon>
                                    </md-button>
                                    <md-menu-content>
                                        <md-menu-item to="/edit-paper">
                                            <span class="md-list-item-text">Edit paper</span>
                                            <md-button class="md-icon-button md-list-action">
                                                <md-icon class="md-primary">edit</md-icon>
                                            </md-button>
                                        </md-menu-item>
                                        <md-menu-item>
                                            <span class="md-list-item-text">Submit paper</span>
                                            <md-button class="md-icon-button md-list-action">
                                                <md-icon
                                                    class="md-primary"
                                                    md-src="/img/ico-submit-paper.svg"
                                                ></md-icon>
                                            </md-button>
                                        </md-menu-item>
                                    </md-menu-content>
                                </md-menu>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- new css paper list 1 -->
            <div v-else>
                <div
                    v-for="paper in papers"
                    :key="paper.id"
                    class="d-flex flex-wrap wrap-my-table-papers py-3 px-3 px-lg-0 mb-4 mb-lg-0"
                >
                    <div class="d-flex flex-column flex-lg-row w-100">
                        <div class="title tab-col col-lg-6 px-0 pr-5 pr-lg-0">
                            <div>{{paper.title}}</div>
                            <div v-if="paper.event_name">
                                <small>
                                    Event:
                                    <strong>
                                        <em>{{paper.event_name}}</em>
                                    </strong>
                                    <div class="cfs-organizer">>by {{paper.organizer_name}}</div>
                                </small>
                            </div>
                        </div>
                        <div
                            v-if="paper.proposals && paper.proposals.length"
                            class="submitted tab-col col-lg-4 px-0 pl-lg-5 pt-3 pt-lg-0"
                        >
                            <span class="mr-1">{{paper.proposals.length}}</span> submitted
                            <md-button
                                class="md-icon-button md-list-action"
                                @click="expanded[paper.id] = !expanded[paper.id]"
                            >
                                <md-icon class="md-primary" v-if="!expanded[paper.id]">add</md-icon>
                                <md-icon class="md-primary" v-else>remove</md-icon>
                            </md-button>
                        </div>
                        <div
                            v-else-if="cospeaker"
                            class="tab-col col-lg-4 px-0 pl-lg-5 pt-3 pt-lg-0"
                        >
                            <paper-status :status="paper.state"></paper-status>
                        </div>
                        <div class="ml-auto wrap-ico tab-col">
                            <md-button
                                class="md-icon-button md-list-action mx-lg-0"
                                v-if="cospeaker && !loading"
                                @click="openProposalInfo(paper)"
                            >
                                <i class="material-icons-outlined thumb">info</i>
                            </md-button>
                            <md-button
                                v-else-if="!loading"
                                :to="{name: 'edit-paper', params: {paperId: paper.id}}"
                                class="md-icon-button md-list-action mx-lg-0"
                            >
                                <md-icon class="md-primary">edit</md-icon>
                            </md-button>
                        </div>
                    </div>

                    <b-collapse
                        v-if="paper.proposals && paper.proposals.length"
                        :id="paper.id + '-collapse'"
                        v-model="expanded[paper.id]"
                        class="info-events-submitted w-100 mt-2"
                        :visible="filtering"
                    >
                        <!-- 1 -->
                        <div class="py-2">
                            <div v-for="proposal in paper.proposals" :key="proposal.id">
                                <div
                                    v-if="proposal.cfp"
                                    class="d-flex px-2 py-2 px-md-3 py-md-3 px-lg-2 py-lg-2 info-events align-items-center flex-wrap"
                                >
                                    <div class="order-1 col-9 col-md-6 px-0 pr-lg-0 pl-lg-2">
                                        {{proposal.event_name}}
                                        <div class="cfs-organizer">
                                            <small>by {{proposal.organizer_name}}</small>
                                        </div>
                                        <div
                                            class="cfp-closes d-flex align-items-center"
                                            v-if="!cfpClosed(proposal.cfp.end_datetime)"
                                        >
                                            <small class="txt-cfs-closes d-flex align-items-center">
                                                <i class="material-icons mr-1">access_time</i>
                                                <div>CFS closes in {{cfsCloseTime(proposal.cfp.end_datetime)}}</div>
                                            </small>
                                        </div>
                                        <div
                                            class="cfp-closes d-flex align-items-center"
                                            v-if="proposal.state === 'EXPIRED' && cfpClosed(proposal.cfp.end_datetime)"
                                        >
                                            <small class="txt-cfs-closed d-flex align-items-center">
                                                <i class="material-icons mr-1">access_time</i>
                                                <div>CFS closed {{cfsCloseTime(proposal.cfp.end_datetime)}} ago</div>
                                            </small>
                                        </div>
                                    </div>
                                    <div
                                        class="order-3 order-md-2 status col-12 col-md-4 px-0 pl-lg-5 pt-2 pt-lg-0"
                                    >
                                        <paper-status :status="proposal.state"></paper-status>
                                    </div>
                                    <div
                                        class="order-2 order-md-3 col-3 col-md-2 d-md-flex align-items-center justify-content-end"
                                    >
                                        <md-button
                                            v-if="proposal.state!== 'DRAFT' && proposal.state!== 'COSPEAKER_REFUSED'"
                                            class="md-icon-button md-list-action mx-lg-0"
                                        >
                                            <i
                                                class="material-icons-outlined"
                                                @click="openProposalInfo(proposal)"
                                            >info</i>
                                        </md-button>
                                        <md-button
                                            v-else
                                            class="md-icon-button md-list-action"
                                            target="_blank"
                                            :href="`//events.codemotion.com/call-for-speakers/${proposal.cfp_slug}?edit=${proposal.id}`"
                                        >
                                            <md-icon
                                                class="md-primary"
                                                md-src="/img/cfs-page2.svg"
                                                title="Edit submission"
                                            ></md-icon>
                                        </md-button>
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="d-flex px-2 py-2 px-md-3 py-md-3 py-lg-2 text-muted info-events align-items-center flex-wrap"
                                >This CFS could not be found.</div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>

            <div
                class="loading-screen d-flex p-4 justify-content-center align-items-center"
                v-if="loading"
            >
                <b-spinner></b-spinner>
            </div>
        </div>
        <b-pagination
            v-if="total"
            class="mb-3 my-lg-3"
            v-model="pageProp"
            :total-rows="total"
            align="center"
            :per-page="perPage"
            @input="changePage"
        ></b-pagination>
        <paper-info-modal
            :key="modalKey"
            v-model="paperDetails"
            :currentPaper="currentPaper"
            :approvable="approvable"
            :isSpeaker="type === 'speaker' && !cospeaker"
            :approve="paper => changeStatus(paper, 'approve')"
            :reject="paper => changeStatus(paper, 'reject')"
        ></paper-info-modal>

        <md-dialog-confirm
            class="state-change-confirm"
            :md-active.sync="stateChangeConfirm"
            md-title="Confirm"
            :md-content="`Are you sure you want to ${statusChange} this paper for this event?`"
            md-confirm-text="Yes"
            md-cancel-text="No"
            @md-cancel="stateChangeConfirm = false"
            @md-confirm="confirmStateChange"
        />
    </div>
    <div class="d-flex align-items-center justify-content-center p-3" v-else>
        <b-spinner v-if="loading"></b-spinner>
        <code-message v-else>
            There are no papers to show.
            <router-link :to="{name: 'new-paper'}" v-if="!filtering">Create one!</router-link>
        </code-message>
    </div>
</template>
<script>
import PaperInfoModal from "@/components/Papers/PaperInfoModal.vue";
import PaperStatus from "@/components/Papers/PaperStatus.vue";
import CodeMessage from "@/components/CodeMessage.vue";
import { isAfter, formatDistanceToNow } from "date-fns";
export default {
    name: "PapersTable",
    props: [
        "papers",
        "type",
        "fields",
        "loading",
        "page",
        "perPage",
        "total",
        "changePage",
        "approve",
        "reject",
        "filtering",
        "cospeaker"
    ],
    components: {
        PaperInfoModal,
        CodeMessage,
        PaperStatus
    },
    computed: {
        pageProp: {
            get() {
                return this.page;
            },
            set(val) {
                this.$emit("page-changed", val);
            }
        },
        profile() {
            return this.$store.getters.profile;
        }
    },
    watch: {
        filtering(val) {
            for (let key in this.expanded) {
                this.expanded[key] = val;
            }
        }
    },
    data: () => ({
        currentPaper: null,
        paperDetails: false,
        modalKey: 0,
        approvable: false,
        stateChangeConfirm: false,
        statusChange: "",
        fieldsOptions: "",
        levelData: {
            FOR_EVERYONE: "Non technical/for everyone",
            BEGINNER: "Beginner",
            INTERMEDIATE: "Intermediate",
            ADVANCED: "Advanced"
        },
        sessionTypeData: {
            LIGHTNING: "Lightning",
            TALK: "Talk",
            WORKSHOP: "Workshop",
            LIVE_CODING: "Live code",
            HANDS_ON: "Hands-on"
        },
        expanded: {}
    }),
    methods: {
        async confirmStateChange() {
            if (this.statusChange === "approve") {
                this.paperDetails = false;
                await this.approve(this.currentPaper);
            } else {
                this.paperDetails = false;
                await this.reject(this.currentPaper);
            }
        },
        cfpClosed(date) {
            return isAfter(new Date(), parseInt(date.$date.$numberLong));
        },
        cfsCloseTime(date) {
            return formatDistanceToNow(parseInt(date.$date.$numberLong));
        },
        goToEdit(id, cfpSlug) {
            window.open(
                "//events.codemotion.com/call-for-speakers/" +
                    cfpSlug +
                    "/?edit=" +
                    id,
                "_blank"
            );
        },
        openProposalInfo(paper, approvable) {
            this.currentPaper = paper;
            this.modalKey++;
            this.paperDetails = true;
            this.approvable = approvable;
        },
        changeStatus(paper, status) {
            this.statusChange = status;
            this.stateChangeConfirm = true;
            this.currentPaper = paper;
        }
    }
};
</script>
<style lang="scss">
.no-mobile {
    @media all and (max-width: 990px) {
        display: none;
    }
}
.only-mobile {
    display: none;
    @media all and (max-width: 990px) {
        display: flex;
    }
}
.state-change-confirm.md-dialog.md-theme-default {
    z-index: 2000 !important;
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";

#wrap-papers-table {
    padding: 15px;
    width: 100%;
    max-width: 1000px;
    // background-color: #fff;
    position: relative;
    @media all and (min-width: $size-tablet-landscape) {
        // padding-bottom: 0;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
        background-color: #fff;
    }
    .cfp-closes {
        i {
            font-size: 15px;
            color: #4f8d0a;
        }
        .txt-cfs-closes {
            color: #4f8d0a;
        }
        .txt-cfs-closed {
            color: red;
        }
    }
    .loading-screen {
        background: #ffffffb0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 5;
        top: 0;
        left: 0;
        border-radius: 5px;
    }
    .table-header {
        display: none;
        font-weight: 700;
        @media all and (min-width: $size-tablet-landscape) {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
        .meetup-header {
            @media all and (min-width: $size-tablet-landscape) {
                width: 22%;
                &:last-child {
                    width: 12%;
                }
            }
        }
        .speaker-header {
            @media all and (min-width: $size-tablet-landscape) {
                width: 31%;
                font-weight: 600;
                &:last-child {
                    width: 6%;
                }
            }
        }
    }
    .table-row {
        position: relative;
        padding: 15px;
        margin-bottom: 20px;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
        border: 1px solid #eaeaea;
        background-color: #ffffff;
        @media all and (min-width: $size-tablet-landscape) {
            padding: 15px 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin: 0;
            border-radius: 0;
            border: none;
            border-top: 1px solid #f0f0f0;
            box-shadow: none;
            & > div {
                display: flex;
                width: 100%;
                & > div {
                    width: 100%;
                }
            }
        }
    }
    .meetup-row {
        padding-bottom: 55px;
        @media all and (min-width: $size-tablet-landscape) {
            padding-bottom: 15px;
            & > div {
                width: 22%;
                padding-right: 15px;
            }
        }
    }
    .speaker-row {
        & > div {
            @media all and (min-width: $size-tablet-landscape) {
                width: 31%;
                padding-right: 15px;
            }
        }
    }
    .title,
    .abstract,
    .event {
        padding-right: 50px;
        small {
            font-size: 11px;
        }
    }

    .cfs-organizer {
        margin-top: -5px;
        margin-bottom: 5px;
    }

    .speaker {
        padding-right: 50px;

        & > div {
            display: flex;
            align-items: center;
        }
        img {
            height: 30px;
            width: 30px;
            border-radius: 50%;
        }
    }
    .length {
        @media all and (max-width: $size-tablet-landscape) {
            height: 25px;
            & > div {
                display: flex;
                align-items: center;
            }
            position: absolute;
            padding-left: 15px;
            bottom: 15px;
            left: 0;
            width: 30%;
        }
    }
    .level {
        max-width: 250px;
        @media all and (max-width: $size-tablet-landscape) {
            position: absolute;
            bottom: 15px;
            right: 0;
            width: 70%;
            padding-right: 15px;
            font-size: 14px;
            text-align: right;
        }
        .progress {
            background: #f8f8f8;
        }
        .progress-bar {
            font-size: 13px;
            color: white;
            background-color: #0d1d308c;
            text-align: left;
            padding-left: 4px;
            &.bg-light {
                color: $palette-blue;
                background-color: #f8f8f8 !important;
                border-color: transparent;
            }
        }
    }
    .actions {
        &.meetup-actions {
            width: 12%;
        }
        &.speaker-actions {
            width: 6%;
        }
        & > div {
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
        padding: 0 !important;
        text-align: right;
        @media all and (max-width: $size-tablet-landscape) {
            width: auto !important;
            position: absolute;
            top: 15px;
            right: 15px;
            span {
                display: flex;
                flex-direction: column-reverse;
            }
            i {
                margin: 0;
            }
        }
        i {
            margin: 0 7px;
            padding: 5px;
            background: #f8f8f8;
            border-radius: 50%;
            color: $palette-orange;
            cursor: pointer;
            transition: all 0.5s ease;
            &:hover {
                background: #f8f8f8;
            }
        }

        .approved {
            position: absolute;
            right: -25px;
            border-radius: 0;
            height: 100%;
            margin: 0;
            top: 0;
            font-size: 15px;
            display: flex;
            align-items: center;
            color: #7ed321;
            cursor: default;
            font-weight: bold;
            background: #f7f7f7;
            transition: none;
            @media all and (min-width: $size-tablet-landscape) {
                position: relative;
                right: 0;
                background: transparent;
            }
            &:hover {
                background: #f7f7f7;
            }
            &.thumb:hover {
                background: transparent;
            }
            @media all and (max-width: $size-tablet-landscape) {
                margin: 0;
                top: -15px;
                right: -15px;
                padding: 5;
                height: auto;
                border-top-left-radius: 0;
                border-bottom-right-radius: 0;
                border-top-right-radius: 5px;
                border-bottom-left-radius: 5px;
                font-size: 12px;
                &:hover {
                    background: #f7f7f7;
                }
            }
        }
        .rejected {
            position: absolute;
            right: -25px;
            border-radius: 0;
            height: 100%;
            margin: 0;
            top: 0;
            font-size: 15px;
            display: flex;
            align-items: center;
            color: red;
            cursor: default;
            font-weight: bold;
            background: #f7f7f7;
            transition: none;
            @media all and (min-width: $size-tablet-landscape) {
                position: relative;
                right: 0;
                background: transparent;
            }
            &:hover {
                background: #f7f7f7;
            }
            &.thumb:hover {
                background: transparent;
            }
            @media all and (max-width: $size-tablet-landscape) {
                margin: 0;
                top: -15px;
                right: -15px;
                padding: 5;
                height: auto;
                border-top-left-radius: 0;
                border-bottom-right-radius: 0;
                border-top-right-radius: 5px;
                border-bottom-left-radius: 5px;
                font-size: 12px;
                &:hover {
                    background: #f7f7f7;
                }
            }
        }
    }

    .txt-table-mobile {
        font-size: 14px;
        font-weight: 600;
    }

    .txt-title-papers {
        font-size: 14px;
    }

    .edit-btn {
        background: #f8f8f8;

        .md-icon {
            background-color: transparent;
            &:hover {
                background-color: transparent;
            }
        }
    }

    .wrap-my-table-papers {
        position: relative;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
        background-color: #ffffff;
        @media all and (min-width: $size-tablet-landscape) {
            box-shadow: none;
            padding: 0;
            border-radius: 0px;
            border-bottom: 1px solid #f0f0f0;
        }

        .tab-col {
            display: flex;
            align-items: center;
        }

        .title {
            font-size: 14px;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
        }

        .submitted {
            font-size: 14px;
            .md-icon-button {
                width: 20px;
                min-width: 20px;
                height: 20px;
            }
            i {
                font-size: 20px !important;
            }
        }

        .wrap-ico {
            position: absolute;
            right: 8px;
            top: 12px;
            @media all and (min-width: $size-tablet-landscape) {
                position: relative;
                right: 0;
                top: 0;
            }
        }

        .md-button.md-theme-default {
            background-color: #f8f8f8;
        }

        .info-events-submitted {
            border-radius: 5px;
            border: solid 1px #dcdcdc;
            font-size: 12px;
            background-color: #f8f8f8;

            .md-icon-button {
                margin: 0;
            }
            .info-events {
                border-bottom: 1px solid #f0f0f0;

                &:last-child {
                    border-bottom: 0px solid #f0f0f0;
                }

                .co-speaker {
                    font-style: italic;
                    font-weight: 600;
                }
            }
            .wrap-ico {
                right: 18px;
            }
        }

        &:last-child {
            border-bottom: 0px solid #f0f0f0;
        }
    }

    .material-icons-outlined {
        top: 1px;
        position: relative;
    }
}
</style>